module.exports = __webpack_public_path__ + "static/media/header-prescryptive-trademark-logo.5a62b36d.svg";